import styled from 'styled-components';

export const DebugButton = styled.button`
  position: fixed;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  background: rgba(0, 0, 0, 0.7);
  color: #0f0;
  border: 1px solid #0f0;
  border-radius: 50%;
  font-size: 18px;
  z-index: 100;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
`;

export const Panel = styled.div<{ $open: boolean }>`
  display: ${({ $open }) => ($open ? 'block' : 'none')};
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  max-height: 55vh;
  background: rgba(0, 0, 0, 0.95);
  color: #0f0;
  font: 11px/1.4 monospace;
  z-index: 100;
  overflow-y: auto;
  padding: 6px;
  border-top: 2px solid #0f0;
  -webkit-overflow-scrolling: touch;
`;

export const PanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
`;

export const PanelTitle = styled.b`
  color: #0ff;
`;

export const ClearButton = styled.button`
  background: #333;
  color: #ff0;
  border: 1px solid #ff0;
  padding: 2px 8px;
  font: 11px monospace;
  margin-right: 4px;
  cursor: pointer;
`;

export const CloseButton = styled.button`
  background: #333;
  color: #f00;
  border: 1px solid #f00;
  padding: 2px 8px;
  font: 11px monospace;
  cursor: pointer;
`;

export const Section = styled.div`
  background: #111;
  padding: 4px;
  margin-bottom: 4px;
  border: 1px solid #555;
`;

export const SectionLabel = styled.b`
  color: #ff0;
`;

export const StorageContent = styled.div`
  white-space: pre-wrap;
  max-height: 80px;
  overflow-y: auto;
  margin-top: 2px;
`;

export const SttContent = styled.div`
  white-space: pre-wrap;
  min-height: 30px;
  max-height: 100px;
  overflow-y: auto;
  margin-top: 2px;
  color: #0ff;
`;

export const LogEntry = styled.div`
  border-bottom: 1px solid #333;
  padding: 2px 0;
  word-break: break-all;
`;
